import React from "react";
import { NodeProps, useReactFlow } from "reactflow";
import styled from 'styled-components';
import { operationType } from "../../../../services/types";
import { updateNodeValue } from "../../../../services/method";
import { Textarea } from "../../../form/textarea";

export function ChatAgent({ id, data }: NodeProps<operationType>) {
   const { setNodes } = useReactFlow();
   // ---
   const handleChangeText = (e: React.ChangeEvent<HTMLInputElement>, keyRef?: string) => {
      updateNodeValue(id, setNodes, { [keyRef as string]: e.target.value });
   }

   return (
      <Main>
         <Textarea keyRef="customerInfo" value={ data.value?.customerInfo } placeholder="Customer Info" handleChange={ handleChangeText } />
         <Textarea keyRef="systemPrompt" value={ data.value?.systemPrompt } placeholder="System Prompt" handleChange={ handleChangeText } />
      </Main>
   );
}

// ---
const Main = styled.div`
   min-width: 350px;
   padding: 7.5px 7.5px 3px;

   textarea { 
      padding: 7.5px;
      font-size: 15px;
      min-height: 80px;
   }
`;